  var inGuard = false;
  var originalWebpackRequire = __webpack_require__;
  function guardedWebpackRequire(moduleId) {
    if (!inGuard && self.ErrorUtils) {
      inGuard = true;
      let exports;
      try {
        exports = originalWebpackRequire(moduleId);
      } catch (e) {
        self.ErrorUtils.reportFatalError(e);
      }
      inGuard = false;
      return exports;
    } else {
      return originalWebpackRequire(moduleId);
    }
  }
  Object.getOwnPropertyNames(originalWebpackRequire).forEach(key => {
    guardedWebpackRequire[key] = originalWebpackRequire[key];
  });
  __webpack_require__ = guardedWebpackRequire;